<div class="container-fluid m-0 p-0" style="min-height: 844px;">

    <div class="row-container p-0 m-0" #rowContainer>
        
        <div class="col-md-4 resizable-column" #column1 >
  
            <mat-card class="mb-25 enrolled-created-box ccorbit-card">
                <mat-card-content>
                    <!-- Loading Spinner -->
                    <div *ngIf="loading" class="loading-spinner">
                        <mat-spinner diameter="40"></mat-spinner>
                    </div>
                    <div *ngIf="loadingCondiciones" class="loading-spinner">
                        <mat-spinner diameter="40"></mat-spinner>
                    </div>

                    <!-- Error Message -->
                    <div *ngIf="error" class="error-message">
                        <mat-error>{{error}}</mat-error>
                    </div>

                    <!-- Content when data is loaded -->
                    <ng-container *ngIf="!loading && !error">
                        <!-- Radio Button Group -->
                        <mat-radio-group [(ngModel)]="selectedType" 
                                       (change)="onTypeChange($event.value)" 
                                       class="radio-group">
                            <mat-radio-button value="INDICADORES" class="radio-button">
                                INDICADORES
                            </mat-radio-button>
                            <mat-radio-button value="RATIOS" class="radio-button">
                                RATIOS
                            </mat-radio-button>
                        </mat-radio-group>

                        <!-- First table (Indicadores) -->
                        <mat-form-field appearance="outline" class="w-100 filter-field">
                          <mat-label>Buscar indicador</mat-label>
                          <input matInput (keyup)="applyIndicadoresFilter($event)" [(ngModel)]="indicadoresFilterValue" placeholder="Ej. adx">
                          <button *ngIf="indicadoresFilterValue" matSuffix mat-icon-button aria-label="Clear" (click)="indicadoresFilterValue=''; applyIndicadoresFilter($event)">
                            <mat-icon>close</mat-icon>
                          </button>
                        </mat-form-field>
            
                        <div class="table-container">
                            <table mat-table [dataSource]="indicadoresDataSource" class="w-100">
                                <!-- Counter Column -->
                                <ng-container matColumnDef="index">
                                    <th mat-header-cell *matHeaderCellDef> # </th>
                                    <td mat-cell *matCellDef="let element; let i = index"> {{i + 1}} </td>
                                </ng-container>

                                <!-- Label Column -->
                                <ng-container matColumnDef="label">
                                    <th mat-header-cell *matHeaderCellDef> Indicador </th>
                                    <td mat-cell *matCellDef="let element"> {{element.label}} </td>
                                </ng-container>
                             
                                 <!-- Action Column (Contador) -->
                                <ng-container matColumnDef="action">
                                    <th mat-header-cell *matHeaderCellDef> Contador </th>
                                    <td mat-cell *matCellDef="let element"> {{element.action}} </td>
                                </ng-container>
                              
                                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                                <tr mat-row *matRowDef="let row; columns: displayedColumnsindi;" 
                                    (click)="onSelectIndicador(row)"
                                    [class.selected-row]="row === selectedRow"
                                    style="cursor: pointer;"></tr>
                            </table>
                        </div>

                      
                    </ng-container>
                </mat-card-content>
            </mat-card>
  
        </div>
  
  
  
        <div class="col-9 p-0 m-0 ">
            <mat-card class="mb-25 enrolled-created-box ccorbit-card">
                <mat-card-content class=" ">
                  
                    <!-- Second table (Condiciones)
                    <mat-form-field appearance="outline" class="w-100 filter-field">
                      <mat-label>Buscar condición</mat-label>
                      <input matInput (keyup)="applyCondicionesFilter($event)" [(ngModel)]="condicionesFilterValue" placeholder="Ej. > 100">
                      <button *ngIf="condicionesFilterValue" matSuffix mat-icon-button aria-label="Clear" (click)="condicionesFilterValue=''; applyCondicionesFilter($event)">
                        <mat-icon>close</mat-icon>
                      </button>
                    </mat-form-field>
             -->
                    <table mat-table [dataSource]="condicionesDataSource" class="w-100">
                        <!-- Counter Column -->
                        <ng-container matColumnDef="index">
                            <th mat-header-cell *matHeaderCellDef> # </th>
                            <td mat-cell *matCellDef="let element; let i = index"> {{i + 1}} </td>
                        </ng-container>

                        <!-- Label Column -->
                        <ng-container matColumnDef="label">
                            <th mat-header-cell *matHeaderCellDef> Condición </th>
                            <td mat-cell *matCellDef="let element"> {{element.label}} </td>
                        </ng-container>
        
                       
                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
  </div>
